import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const customerPhonesTypes = async () => axios.get(Routes.CUSTOMER_PHONES_TYPES);

export const useCustomerPhonesTypes = () =>
  useQuery({
    queryKey: [Keys.CUSTOMER_PHONES_TYPES_QRY],
    queryFn: customerPhonesTypes,
  });
